import GoogleAdsAppDrawer from './GoogleAdsAppDrawer';

const drawers = [GoogleAdsAppDrawer];

export default drawers;
